export const MIN_MAP_EDITABLE_ZOOM_LEVEL = 17;
export const INITIAL_GEOLOCATION_MAP_ZOOM = 14;
export const MIN_MAP_POI_ZOOM_LEVEL = 14;
export const MIN_MAP_POI_SELECTED_ZOOM_LEVEL = 19; // on this zoom level all POI must be visible. Keep in sync with filterPoiExpression in "POILayerStyle.tsx". Otherwise, selected POI could have a pin (red marker) but will not have, for example, label because label is a part of POI and POI filtered out by zoom level.

// used by edit suggestions api to enable different features per each entity version
export const EDIT_SUGGESTION_VERSION = '1.11';

export const CRITICAL_POIS_CATEGORIES = [
  'airport',
  'government',
  'monument',
  'university',
  'stadium',
  'museum',
  'historic_site',
  'historic site', // Separated via space in some cases
  'viewpoint',
  'tourist_attraction',
  'tourist attraction', // Separated via space in some cases ("Karesuando Turist Information")
];

export const EDIT_SUGGESTION_LABELS = {
  // Edit suggestion should be not updated automatically
  critical_poi: 'critical_poi',
};

export const LOCATION_SEARCH_PARAM_NAME = 'l';

export enum EDIT_SUGGESTION_TYPES {
  poi = 'poi',
  address = 'address',
  road = 'road',
  speedLimit = 'speedLimit',
  incident = 'incident',
  clearance = 'clearance',
}

export const ITEM_TYPES = {
  poi: 'poi',
  address: 'address',
  road: 'road',
} as const;

export const ITEM_TYPES_EDIT_SUGGESTION_TYPES = {
  [ITEM_TYPES.poi]: EDIT_SUGGESTION_TYPES.poi,
  [ITEM_TYPES.address]: EDIT_SUGGESTION_TYPES.address,
};

export const ENV = {
  DEV: 'development',
  TEST: 'test',
  LOCAL: 'local',
  STAGING: 'staging',
  PRODUCTION: 'production',
};

export const FEATURES = {
  ROADS_EDIT: 'roads-edit',
  CLICKABLE_BUILDINGS: 'clickable-buildings',
};

export const COUNTRIES_WITH_MILES_CODES = {
  AG: 'Antigua and Barbuda',
  BS: 'Bahamas',
  BZ: 'Belize',
  DM: 'Dominica',
  GD: 'Grenada',
  MH: 'Marshall Islands',
  FM: 'Micronesia',
  PW: 'Palau',
  KN: 'Saint Kitts and Nevis',
  LC: 'Saint Lucia',
  VC: 'Saint Vincent and the Grenadines',
  GB: 'United Kingdom',

  /* British Overseas Territories */
  AI: 'Anguilla',
  VG: 'British Virgin Islands',
  IO: 'British Indian Ocean Territory',
  KY: 'Cayman Islands',
  FK: 'Falkland Islands',
  MS: 'Montserrat',
  SH: 'Saint Helena',
  TC: 'Turks and Caicos Islands',

  /* Crown dependencies */
  GG: 'Guernsey',
  IM: 'Isle of Man',
  JE: 'Jersey',

  US: 'United States',

  /*  United States overseas dependencies */
  AS: 'American Samoa',
  GU: 'Guam',
  MP: 'Northern Mariana Islands',
  PR: 'Puerto Rico',
  VI: 'U.S. Virgin Islands',
};

/**
 * 10cm accuracy
 */
export const MAP_COORDS_PRECISION = 6;
